'use client'

// src/api/common/schedule.ts
var SCHEDULE_QUERY = `
title
text
openDateTime
closeDateTime
`;

export {
  SCHEDULE_QUERY
};
//# sourceMappingURL=chunk-HLVUCALY.mjs.map